import { services } from "../../../../constants/services";
import { getByQuery } from "../../../../utils/api";
import { IParamsReservationsLimit, ResponseQ } from "../../../../common/dtos/paginate.dto";

export class GetEnabledCampuSWithPaginationService {
  async run(params: IParamsReservationsLimit) {
    const response = await getByQuery<ResponseQ<any>>(`${services.rooms}/campus`, params);
    return response;
  };
}

